import { useContext } from 'react'
import { TableDataContext } from '@/context/TableDataContext'

export const useTableData = () => useContext(TableDataContext)
